// localStorage keys the app names in more than one place.
export const STORAGE_KEYS = {
  USER_EMAIL: "userEmail",
} as const;
